(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.IDPCalculatorCore = api;
})(typeof window !== "undefined" ? window : globalThis, function () {
  "use strict";

  function toNumber(value, fallback) {
    var parsed = Number.parseFloat(String(value == null ? "" : value).replace(",", "."));
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function round(value, decimals) {
    var factor = Math.pow(10, decimals == null ? 2 : decimals);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }

  function packagePlan(requiredKg, packageSizes) {
    var sizes = (packageSizes || [])
      .map(function (size) { return toNumber(size, 0); })
      .filter(function (size) { return size > 0; })
      .sort(function (a, b) { return b - a; });

    if (!sizes.length || requiredKg <= 0) return { units: [], suppliedKg: 0, excessKg: 0 };

    var smallest = sizes[sizes.length - 1];
    var maxUnits = Math.ceil(requiredKg / smallest) + sizes.length + 2;
    var best = null;

    function visit(index, remainingUnits, counts) {
      if (index === sizes.length - 1) {
        var finalCounts = counts.concat(remainingUnits);
        var supplied = finalCounts.reduce(function (sum, count, position) {
          return sum + count * sizes[position];
        }, 0);
        if (supplied + 1e-9 < requiredKg) return;
        var totalUnits = finalCounts.reduce(function (sum, count) { return sum + count; }, 0);
        var candidate = { counts: finalCounts, supplied: supplied, totalUnits: totalUnits };
        if (!best || supplied < best.supplied - 1e-9 ||
          (Math.abs(supplied - best.supplied) < 1e-9 && totalUnits < best.totalUnits)) {
          best = candidate;
        }
        return;
      }

      for (var count = 0; count <= remainingUnits; count += 1) {
        visit(index + 1, remainingUnits - count, counts.concat(count));
      }
    }

    for (var units = 1; units <= maxUnits; units += 1) visit(0, units, []);
    if (!best) return { units: [], suppliedKg: 0, excessKg: 0 };

    return {
      units: sizes.map(function (size, index) { return { size: size, count: best.counts[index] }; })
        .filter(function (item) { return item.count > 0; }),
      suppliedKg: round(best.supplied, 2),
      excessKg: round(best.supplied - requiredKg, 2)
    };
  }

  function calculateLayer(areaM2, wastePercent, layer) {
    var consumption = Math.max(0, toNumber(layer.consumption, 0));
    var coats = Math.max(1, Math.round(toNumber(layer.coats, 1)));
    if (layer.quantityUnit === "L") {
      var netLitres = Math.max(0, toNumber(areaM2, 0)) * consumption * coats;
      var requiredLitres = netLitres * (1 + Math.max(0, toNumber(wastePercent, 0)) / 100);
      return { name: layer.name || "Producto IDP", phase: layer.phase || "Capa",
        consumption: consumption, coats: coats, quantityUnit: "L",
        netQuantity: round(netLitres, 2), requiredQuantity: round(requiredLitres, 2),
        netLitres: round(netLitres, 2), requiredLitres: round(requiredLitres, 2),
        packages: { units: [], suppliedKg: 0, excessKg: 0, requiresDensity: true,
          note: "Formato nominal25 kg. Densidad/volumen útil pendientes: no calcular envases desde litros." } };
    }
    var netKg = Math.max(0, toNumber(areaM2, 0)) * consumption * coats;
    var requiredKg = netKg * (1 + Math.max(0, toNumber(wastePercent, 0)) / 100);
    var packages = packagePlan(requiredKg, layer.packages || []);
    return {
      name: layer.name || "Producto IDP",
      phase: layer.phase || "Capa",
      consumption: consumption,
      coats: coats,
      netKg: round(netKg, 2),
      requiredKg: round(requiredKg, 2),
      packages: packages
    };
  }

  function calculate(areaM2, wastePercent, layers) {
    var rows = (layers || []).map(function (layer) {
      return calculateLayer(areaM2, wastePercent, layer);
    });
    var litres = rows.filter(function (row) { return row.quantityUnit === "L"; });
    var result = {
      areaM2: round(Math.max(0, toNumber(areaM2, 0)), 2),
      wastePercent: round(Math.max(0, toNumber(wastePercent, 0)), 1),
      rows: rows,
      totalRequiredKg: round(rows.reduce(function (sum, row) { return sum + (row.quantityUnit === "L" ? 0 : row.requiredKg); }, 0), 2)
    };
    if (litres.length) result.totalRequiredLitres = round(litres.reduce(function (sum, row) { return sum + row.requiredLitres; }, 0), 2);
    return result;
  }

  return { toNumber: toNumber, round: round, packagePlan: packagePlan, calculateLayer: calculateLayer, calculate: calculate };
});
